import { render } from "./ContractsRegulationsBox.vue?vue&type=template&id=e01e1ee6"
import script from "./ContractsRegulationsBox.vue?vue&type=script&lang=js"
export * from "./ContractsRegulationsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__